var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button is-small is-primary logout",on:{"click":_vm.logout}},[_vm._v("Log Me Out "),_c('i',{staticClass:"fa fa-sign-out"})])}
var staticRenderFns = []

export { render, staticRenderFns }